import router from '../../router'
import Message_TemplateService from '../../services/WA_Message_TemplateService'

const state = () => ({
    loadingMessage_Templates: false,
    message_template: null,
    message_templates: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_message_template: false
})
  
const mutations = {
    SET_MESSAGE_TEMPLATE: (state, payload) => {
        state.message_template = payload
    },
    SET_MESSAGE_TEMPLATES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.message_templates = payload.itens
        }else{
            state.message_templates = [...state.message_templates, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_MESSAGE_TEMPLATES: (state, payload) => {
        state.loadingMessage_Template = payload
    },
    SET_SHOW_MODAL_MESSAGE_TEMPLATE: (state, payload) => {
        state.show_modal_new_message_template = payload
    },
}

const actions = {
    async fetchMessage_Template({commit}, id){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const response = await Message_TemplateService.getOne(id);
            commit('SET_MESSAGE_TEMPLATE', response.data)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchMessage_Templates({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await Message_TemplateService.get(keyword, pageNumber, pageSize, order);
            commit('SET_MESSAGE_TEMPLATES', response.data)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createMessage_Template({commit}, data){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const response = await Message_TemplateService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_MESSAGE_TEMPLATE', false)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeMessage_Template({commit}, data){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const response = await Message_TemplateService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getMessage_Template: state => state.message_template,
    getMessage_Templates: state => state.message_templates,
    getLoadingMessage_Template: state => state.loadingMessage_Template,
    getShowModalNewMessage_Template: state => state.show_modal_new_message_template
}

export default {
    state,
    getters,
    mutations,
    actions
};